import React, { useEffect } from 'react';
import './App.css';
import Hero from './components/Hero';
import Services from './components/Services';
import TechStack from './components/TechStack';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <div className="App min-h-screen bg-[#0a0a0a] text-white">
      <Hero />
      <Services />
      <TechStack />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;